module.exports = __webpack_public_path__ + "static/media/polar-mint3@3x.d2a627af.png";